<template>
  <div ref="container" class="turnstile-widget"></div>
</template>

<script>
const SCRIPT_ID = 'cloudflare-turnstile-script';
const SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

function loadTurnstile() {
  if (window.turnstile) return Promise.resolve(window.turnstile);

  return new Promise((resolve, reject) => {
    let script = document.getElementById(SCRIPT_ID);
    const onLoad = () => {
      if (window.turnstile) {
        script.dataset.turnstileState = 'loaded';
        resolve(window.turnstile);
      } else {
        script.dataset.turnstileState = 'failed';
        reject(new Error('Turnstile did not initialize'));
      }
    };
    const onError = () => {
      script.dataset.turnstileState = 'failed';
      script.remove();
      reject(new Error('Turnstile script failed to load'));
    };

    if (script) {
      if (script.dataset.turnstileState === 'failed') {
        script.remove();
        script = null;
      } else if (script.dataset.turnstileState === 'loaded') {
        reject(new Error('Turnstile did not initialize'));
        return;
      }
    }

    if (script) {
      script.addEventListener('load', onLoad, { once: true });
      script.addEventListener('error', onError, { once: true });
      return;
    }

    script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = SCRIPT_URL;
    script.async = true;
    script.defer = true;
    script.dataset.turnstileState = 'loading';
    script.addEventListener('load', onLoad, { once: true });
    script.addEventListener('error', onError, { once: true });
    document.head.appendChild(script);
  });
}

export default {
  name: 'TurnstileWidget',
  props: {
    siteKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isActive: true,
      turnstileApi: null,
      widgetId: null,
    };
  },
  mounted() {
    if (!this.siteKey) {
      this.$emit('error');
      return;
    }

    loadTurnstile()
      .then((turnstile) => {
        if (!this.isActive) return;
        this.turnstileApi = turnstile;
        this.widgetId = turnstile.render(this.$refs.container, {
          sitekey: this.siteKey,
          size: 'flexible',
          callback: token => this.$emit('verified', token),
          'expired-callback': () => this.$emit('expired'),
          'error-callback': () => this.$emit('error'),
        });
      })
      .catch(() => {
        if (this.isActive) this.$emit('error');
      });
  },
  beforeDestroy() {
    this.isActive = false;
    if (this.turnstileApi && this.widgetId !== null && this.turnstileApi.remove) {
      this.turnstileApi.remove(this.widgetId);
    }
  },
  methods: {
    reset() {
      if (this.turnstileApi && this.widgetId !== null && this.turnstileApi.reset) {
        this.turnstileApi.reset(this.widgetId);
      }
    },
  },
};
</script>
